$(document).ready(function() {
  // CART
  // Open Cart
  $('.ud-toggle-cart').on('click tap', function(e) {
    var headerHeight = $('.ud-cart-header').outerHeight(),
        footerHeight = $('.ud-cart-checkout').outerHeight(),
        height = headerHeight + footerHeight;

    setTimeout(function() {
      //$('.ud-cart-items').css({'height': 'calc(100vh - ' + height + 'px)', 'margin-top': headerHeight + 'px'});
      $('body').toggleClass('ud-cart-open').find('.ud-cart-menu').toggleClass('ud-open');
      $('#navbarContentAlt').collapse('hide');
      // initRipple();
    }, 250);
  });

  // Close Cart
  $('.ud-close-cart').on('click tap', function(e) {
    // $(this).closest('.ud-cart-menu').removeClass('ud-open');
    $('.ud-cart-menu').removeClass('ud-open');
    $('body').removeClass('ud-cart-open');
  });

  // Open cart if url contains #CART
  if ( window.location.href.includes('#cart') ) {
    $('.ud-toggle-cart').first().trigger('click')
  }

  // Search Bar 
  $('.search-bar').on("click", function (e) {
    e.stopPropagation();
  });
  $(".search_icon").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).next().toggle();
  });

  $('.user_logout svg').on("click", function (e) {
    $('.user_account').slideToggle();
    $('.search-bar').hide(); 
    e.preventDefault();
    e.stopPropagation();
  });

  $('.user_account').on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function () { 
    $('.user_account').hide();     
    $('.search-bar').hide();     
  });

  $('.menu_toggle').on('click',function(){
    $(this).toggleClass('open');
    $('.mobile-nav').slideToggle();
    $('.site-header .search-bar').hide();
  });


  // Swatches
  $('.swatches .color').each(function() {
    if (brightnessByColor($(this).css('background-color')) > 200) {
      $(this).css('box-shadow', '0 0px 3px rgba(0,0,0,0.5)')
    }
  })
  /**
   * Calculate brightness value by RGB or HEX color.
   * @param color (String) The color value in RGB or HEX (for example: #000000 || #000 || rgb(0,0,0) || rgba(0,0,0,0))
   * @returns (Number) The brightness value (dark) 0 ... 255 (light)
   */
  function brightnessByColor (color) {
    var color = "" + color, isHEX = color.indexOf("#") == 0, isRGB = color.indexOf("rgb") == 0;
    if (isHEX) {
      const hasFullSpec = color.length == 7;
      var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
      if (m) var r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16), g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16), b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16);
    }
    if (isRGB) {
      var m = color.match(/(\d+){3}/g);
      if (m) var r = m[0], g = m[1], b = m[2];
    }
    if (typeof r != "undefined") return ((r*299)+(g*587)+(b*114))/1000;
  }

  // FIXED HEADER Watch Fixed Navbar Height and Adjust top padding of MainContent
  // const resizeObserver = new ResizeObserver(entries => {
  //   for (const entry of entries) {
  //     if(entry.contentRect) {
  //       $('#MainContent').css('margin-top', entry.contentRect.height);
  //     }
  //   }
  // });
  // resizeObserver.observe($('#HeaderContainer')[0]);

})
